<template>
  <h1>404 - Error - Please retry <router-link :to="{ name: 'LoginPage' }">Login</router-link></h1>
</template>

<script setup lang="ts"></script>

<style scoped></style>
